import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import React, { useMemo } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { servicePackageServiceDelete } from "../store/actions"
import { selectServiceById } from "../store/reducers/serviceReducer"

export const ServicePackageService = ({ servicePackage }) => {
	const { servicepackageserviceid, serviceid } = servicePackage
	// Get service date by id
	const serviceObj = useSelector((state) => {
		return selectServiceById(state, serviceid)
	}, shallowEqual)
	const sObj = useMemo(() => {
		return serviceObj
	}, [serviceObj])

	const dispatch = useDispatch()
	const spsDelete = (spsid, spid, sid, pid) => dispatch(servicePackageServiceDelete(spsid, spid, sid, pid))

	return (
		<ListItem key={serviceObj.serviceid} sx={{ width: 250 }}>
			<ListItemText primary={serviceid + " - " + sObj.title + " - " + sObj.description} />
			<DeleteForeverIcon onClick={() => spsDelete(servicepackageserviceid)} />
		</ListItem>
	)
}
